import {nanoid} from 'nanoid';
import {selfemloyedBusiness} from '@/static/pages/constants/creditRates';
import {
    bannerRate,
    comfort,
    urgent,
    classic,
    minimumBalance,
} from '@/static/pages/constants/buisnessDeposits';
import {CREDIT_CALC_ID, CREDIT_FORM_ID} from '@/core/constants/common';
import {KK_ID, RA_ID, SK_ID} from '@/core/constants/regions';

/**
 * core/models/pages/business-page/AcquiringModel.js
 */
export const acquiringSlide = {
    slideImg: 'components/acquiring/acquiring.jpg',
    slideImgTablet: 'components/acquiring/acquiring-780.jpg',
    slideImgMobile: 'components/acquiring/acquiring-mob.jpg',
    imageAlt: 'Эквайринг 1%',
    slideTitle: 'Эквайринг 1%',
    slideValue: [
        {
            value: '',
            name: 'Для социально значимых видов<br> деятельности и товаров',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'подключить',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
        {
            id: nanoid(),
            link: '#promo',
            title: 'подробнее',
            additionalClasses: ['cibButton_simple', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/AcquiringModel.js
 */
export const merchantAcquiringSlide = {
    slideImg: 'components/acquiring/banner-slide1.webp',
    slideImgTablet: 'components/acquiring/banner-slide-tablet.png',
    slideImgMobile: 'components/acquiring/banner-slide-mob.png',
    imageAlt: 'Торговый эквайринг в надежном банке',
    slideTitle: 'Торговый эквайринг в&nbsp;надежном банке',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Бесплатно предоставим терминал, расходные материалы и&nbsp;техническое обслуживание',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'подключить',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
        {
            id: nanoid(),
            link: '#acquiring-calc',
            title: 'подобрать тариф',
            additionalClasses: ['cibButton_simple', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/AcquiringModel.js
 * core/models/pages/business-page/BusinessModel.js
 */
export const onlineCashAcquiringSlide = {
    slideImg: 'components/business-page/online-checkout-with-acquiring.jpg',
    slideImgMobile: 'components/business-page/online-checkout-with-acquiring-mob.webp',
    imageAlt: 'Онлайн-касса с эквайрингом',
    slideTitle: 'Онлайн-касса с&nbsp;эквайрингом',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: `
                Бесплатно для клиентов при открытии расчётного счета
                и&nbsp;подключении эквайринга
            `,
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `/business/acquiring#${CREDIT_FORM_ID}`,
            title: 'подключить',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/BankGuarantees.js
 */
export const bankGuaranteesSlide = {
    slideImg: 'pages/business/bank-guarantee/banner-image.png',
    slideImgTablet: 'pages/business/bank-guarantee/banner-image-small.png',
    slideImgMobile: 'pages/business/bank-guarantee/banner-420.png',
    imageAlt: 'Банковские гарантии для бизнеса',
    slideTitle: 'Банковские гарантии для бизнеса',
    slideValue: [
        {
            value: '',
            name: 'Без документов для бизнеса',
        },
        {
            value: '',
            name: 'Оформление за&nbsp;один день',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'подать заявку',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
        iconValue: true,
    },
};

/**
 * core/models/pages/business-page/BusinessModel.js
 */
export const buisnessAcquiringSlide = {
    slideImg: 'components/acquiring/acquiring.jpg',
    slideImgTablet: 'components/acquiring/acquiring-780.jpg',
    slideImgMobile: 'components/acquiring/acquiring-mob.jpg',
    imageAlt:
        'Эквайринг 1% для социально значимых видов деятельности и товаров',
    slideTitle: 'Эквайринг 1%',
    slideValue: [
        {
            value: '',
            name: 'Для социально значимых видов<br> деятельности и товаров',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `/business/acquiring#${CREDIT_FORM_ID}`,
            title: 'подключить',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
        {
            id: nanoid(),
            link: '/business/acquiring#promo',
            title: 'подробнее',
            additionalClasses: ['cibButton_simple', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/BusinessModel.js
 * core/models/pages/business-page/CreditingModel.js
 */
export const buisnessOnlineCreditSlide = {
    slideImg: 'components/business-page/online-credit-bg.png',
    slideImgTablet: 'components/business-page/online-credit-bg1-780.png',
    slideImgMobile: 'components/business-page/online-credit-bg-mobile.webp',
    imageAlt: 'Онлайн кредит до 20 млн ₽',
    slideTitle: 'Онлайн кредит<br>до 20&nbsp;млн&nbsp;&#8381;',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Без документов',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/business-creditform/?prog=onlain-kredit',
            title: 'подать заявку',
            additionalClasses: ['cibButton_big'],
        },
        {
            id: nanoid(),
            link: '/business/business-crediting/onlain-kredit',
            title: 'Подробнее',
            additionalClasses: ['cibButton-as_link'],
        },
    ],
    containerClasses: ['biz-online-credit'],
};

/**
 * core/models/pages/business-page/CorporateCardsModel.js
 */
export const corporateCardsSlide = {
    slideImg: 'pages/business/corporate-cards/corporate-cards-banner.png',
    slideImgMobile: 'pages/business/corporate-cards/banner-420.webp',
    imageAlt: 'Корпоративные карты Business',
    slideTitle: 'Корпоративные <br> карты Business',
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/corporatecard',
            title: 'оформить карту',
            additionalClasses: ['cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/CreditingModel.js
 */
export const businessDevelopmentCreditSlide = {
    slideImg: 'pages/business/businessCrediting/note.png',
    imageAlt: 'Кредит на развитие бизнеса по сниженной ставке',
    slideTitle: 'Кредит на&nbsp;развитие бизнеса по&nbsp;сниженной ставке',
    slideValue: [
        {
            name: 'Cтавка снижена на&nbsp;1% до&nbsp;31&nbsp;декабря',
        },
        {
            name: 'Период проведения акции с&nbsp;15.10.2021 по&nbsp;31.12.2021',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/business-creditform/?prog=onlain-kredit',
            title: 'заявка',
        },
        {
            id: nanoid(),
            link: '/business/business-crediting/tsifrovaia-transformatsiia-dlia-biznesa',
            title: 'Подробнее',
            additionalClasses: ['cibButton-as_link'],
        },
    ],
    slideOptions: {
        bigContent: true,
    },
};

/**
 * core/models/pages/business-page/CreditingModel.js
 */
export const buisnessAcceleratorSlide = {
    slideImg: 'pages/business/businessCrediting/accelerator-bg.jpg',
    slideImgMobile:
        'pages/business/businessCrediting/accelerator-bg-mobile.jpg',
    imageAlt: 'Бесплатный акселератор для бизнеса',
    slideTitle: 'Бесплатный <br> акселератор',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Пройди бесплатное обучение и сделай <br> свой бизнес успешнее вместе с опытной <br> командой',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://acc.centrinvest.ru/#sendrequest',
            title: 'подробнее',
        },
    ],
    slideOptions: {
        bigContent: true,
    },
};

/**
 * core/models/pages/business-page/EnergySaving.js
 */
export const energySavingSlide = {
    slideImg: 'pages/business/energy-investment/banner.png',
    slideImgMobile: 'pages/business/energy-investment/banner-420.png',
    imageAlt: 'Стимулирование инвестиций в энергосбережение',
    slideTitle: 'Стимулирование инвестиций в&nbsp;энергосбережение',
    slideValue: [
        {
            value: '',
            name: '',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/energy-efficiency/',
            title: 'Рассчитать',
        },
    ],
    slideOptions: {
        target: '_blank',
    },
};

/**
 * core/models/pages/business-page/LeasingModel.js
 */
export const buisnessLeasingSlide = {
    slideImg: 'components/leasing/leasing-banner.png',
    slideImgTablet: 'components/leasing/leasing-banner-tablet.png',
    slideImgMobile: 'components/leasing/leasing-420.png',
    imageAlt: 'Финансовый лизинг',
    slideTitle: 'Финансовый лизинг',
    slideValue: [
        {
            value: '',
            name: 'Возможность аренды с&nbsp;последующим <br/>выкупом оборудования и&nbsp;автотранспорта',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/business-creditform/',
            title: 'подать заявку',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
        {
            id: nanoid(),
            link: '#leasing-calc',
            title: 'рассчитать',
            additionalClasses: ['cibButton_simple', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/SalaryProjectsModel.js
 */
export const buisnessSalaryProjectSlide = {
    slideImg: 'components/salary-projects/salary-banner.png',
    slideImgMobile: 'components/salary-projects/salary-banner-420.webp',
    imageAlt: 'Зарплатный проект',
    slideTitle: 'Зарплатный проект',
    slideValue: [
        {
            value: '0&#8381;',
            name: 'выпуск и&nbsp;обслуживание карт',
        },
        {
            value: '0&#8381;',
            name: 'за&nbsp;перечисление зарплаты',
        },
        {
            value: '0&#8381;',
            name: 'обслуживание расчетного счета в&nbsp;течение 3-х месяцев',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: '#sp-feedback',
            title: 'подать заявку',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
 */
export const selfemloyedBusinessCreditSlide = {
    slideImg: 'components/business-page/banner-self.jpg',
    slideImgMobile: 'components/business-page/selfemployed-420.png',
    imageAlt: 'Кредит на развитие бизнеса для самозанятых',
    slideTitle: `
        Кредит на&nbsp;развитие бизнеса для самозанятых ${selfemloyedBusiness.rate}%
    `,
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/new-creditform/start/?selfjob=1&creditType=1&selfCredtarget=1',
            title: 'оформить',
        },
        {
            id: nanoid(),
            link: `#${CREDIT_CALC_ID}`,
            title: 'рассчитать',
            additionalClasses: ['cibButton_simple'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
 */
export const selfemloyedCreditCardSlide = {
    slideImg: 'pages/business/selfemployed/slide1.png',
    slideImgTablet: 'pages/business/selfemployed/selfemployed-tablet.png',
    slideImgMobile: 'pages/business/selfemployed/selfemployed-420.jpg',
    imageAlt: 'Карта с кешбэком и процентами на остаток для самозанятых',
    slideTitle:
        'Карта с&nbsp;кешбэком и&nbsp;процентами на&nbsp;остаток для самозанятых',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: '',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: '/for-individuals/cards/debet-cards/selfemployed-card',
            title: 'оформить',
        },
    ],
    containerClasses: ['selfymployed-slide'],
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
 */
export const selfemloyedAcceleratorSlide = {
    slideImg: 'pages/business/selfemployed/slide2.png',
    slideImgTablet: 'pages/business/selfemployed/slide2-small.png',
    slideImgMobile: 'pages/business/selfemployed/slide-420.png',
    imageAlt: 'Акселератор для самозанятых',
    slideTitle: 'Акселератор для&nbsp;самозанятых',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Пройди бесплатное обучение и&nbsp;сделай свой бизнес успешнее вместе с&nbsp;опытной командой',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://acc.centrinvest.ru/sz',
            title: 'Подробнее',
        },
    ],
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
 */
export const selfemloyedCreditSlide = {
    slideImg: 'components/business-page/banner-self.jpg',
    imageAlt: 'Кредит на развитие бизнеса для самозанятых',
    slideTitle: 'Кредит на&nbsp;развитие бизнеса для самозанятых',
    slideValue: [
        {
            value: `от&nbsp;${selfemloyedBusiness.rate}%
            <a href="#selfemployed-loan-business-info" class="link-black">*</a>`,
            name: 'cтавка',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/new-creditform/start/?selfjob=1&creditType=1&selfCredtarget=1',
            title: 'оформить',
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/TradeFinanceModel.js
 */
export const tradeOperationsFinancingSlide = {
    slideImg: 'pages/trade-finance/trade-finance.jpg',
    slideImgMobile: 'pages/trade-finance/trade-finance-420.jpg',
    imageAlt: 'Финансирование внешнеторговых операций',
    slideTitle: 'Торговое финансирование',
    slideValue: [
        {
            id: nanoid(),
            value: '',
            name: 'Финансирование внешнеторговых операций <br>по&nbsp;Программе торгового финансирования',
        },
    ],
};

/**
 * core/models/pages/business-page/rko/RKOModel.js
 */

export const rkoBuisnessAccountSlide = {
    slideImg: 'pages/business/rko/mainSlide1.png',
    slideImgTablet: 'pages/business/rko/mainSlide1-small.png',
    slideImgMobile: 'pages/business/rko/mainSlide1-mob.png',
    imageAlt: 'Расчетный счет для бизнеса от 0 ₽/мес',
    slideTitle: 'Расчетный счет для&nbsp;бизнеса',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Cтоимость обслуживания от&nbsp;0&nbsp;&#8381;/мес',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'открыть',
        },
        {
            id: nanoid(),
            link: '#rko-tariff-selection',
            title: 'подобрать тариф',
            additionalClasses: ['cibButton_simple', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/rko/RKOModel.js
 */
export const rkoCardsSlide = {
    slideImg: 'pages/business/rko/mainSlide2.png',
    slideImgMobile: 'pages/business/rko/mainSlide2-mob.png',
    imageAlt: 'Корпоративные карты Business',
    slideTitle: 'Корпоративные карты Business',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Удобный платежный продукт для вашего бизнеса',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/corporatecard/',
            title: 'оформить',
        },
        {
            id: nanoid(),
            link: '/business/corporate-cards',
            title: 'Подробнее',
            additionalClasses: ['cibButton_simple', 'cibButton_big'],
        },
    ],
    slideOptions: {
        bigContent: true,
    },
};

/**
 * core/models/pages/business-page/rko/RKOSpecialModel.js
 */
export const rkoSpecialOfferSlide = {
    slideImg: 'pages/business/rko/mainSlide3.png',
    slideImgMobile: 'pages/business/rko/mainSlide3-small.png',
    slideImgMobileVertical: 'pages/business/rko/mainSlide3-mob.jpg',
    imageAlt:
        'Специальное предложение для участников внешнеэкономической деятельности',
    slideTitle: 'Специальное предложение',
    slideValue: [
        {
            value: '',
            name: 'для участников внешнеэкономической<br/> деятельности',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'открыть счет',
            additionalClasses: ['cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * core/models/pages/business-page/rko/RKOYuanModel.js
 */
export const rkoChinaDollarSlide = {
    slideImg: 'pages/business/rko/rko-currency-banner.webp',
    slideImgMobile: 'pages/business/rko/rko-currency-banner-mobile.webp',
    imageAlt: 'Валютное РКО',
    slideTitle: 'Валютное РКО',
    slideValue: [
        {
            value: '',
            name: `
                в&nbsp;манатах, китайских юанях <br>
                и&nbsp;турецких лирах
            `,
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'открыть счет',
            additionalClasses: ['cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
        isRelative: true,
    },
};

export const clientBankSlide = {
    slideImg: 'pages/business/client-bank/client-bank-slide.webp',
    slideImgMobile:
        'pages/business/client-bank/client-bank-slide-mob.jpg',
    imageAlt: 'Система дистанционного банковского обслуживания для бизнеса',
    slideTitle: 'Клиент-банк',
    slideValue: [
        {
            value: '',
            name: 'Система дистанционного банковского <br> обслуживания (СДБО) для бизнеса',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://dbo.centrinvest.ru/sbns-web/ru/html/login.html',
            title: 'войти в систему',
            additionalClasses: ['cibButton_main'],
        },
        {
            id: nanoid(),
            link: '#download',
            title: 'скачать приложение',
            additionalClasses: ['cibButton_simple client-bank__download-btn'],
        },
    ],
    slideOptions: {
        iconValue: false,
        target: '_self',
    },
};

export const businessDepositsSlide = {
    slideImg: 'pages/business/deposits/business-deposits-slide.png',
    slideImgMobile:
        'pages/business/deposits/business-deposits-slide-mob.webp',
    imageAlt: 'Депозиты для бизнеса',
    slideTitle: `Депозиты для бизнеса до ${bannerRate}%`,
    slideLinks: [
        {
            link: '#deposits-calc',
            title: 'Подробнее',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const businessDepositsSlideCiOnline = {
    slideImg: 'pages/business/deposits/business-deposits-slide-ci-online.png',
    slideImgMobile:
        'pages/business/deposits/business-deposits-slide-ci-online-mob.png',
    imageAlt: 'Выгодные ставки',
    slideTitle: 'Выгодные ставки',
    slideValue: [
        {
            value: '',
            name: 'Открой депозит для бизнеса за несколько минут<br>через "Центр-инвест Бизнес онлайн"',
        },
    ],
    slideLinks: [
        {
            link: '#deposits-calc',
            title: 'Подробнее',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const businessDepositsSlideComfort = {
    slideImg: 'pages/business/deposits/deposits/banner-comfort.png',
    slideImgTablet: 'pages/business/deposits/deposits/banner-comfort-tablet.png',
    slideImgMobile:
        'pages/business/deposits/deposits/banner-comfort-mobile.webp',
    imageAlt: 'Депозит «Комфортный»',
    slideTitle: `Депозит «Комфортный» <br> до ${comfort.percent}%`,
    slideValue: [
        {
            value: '',
            name: 'Выплата процентов каждые 30 дней',
        },
    ],
    slideLinks: [
        {
            link: '#deposits-calc',
            title: 'рассчитать',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const businessDepositsSlideClassic = {
    slideImg: 'pages/business/deposits/deposits/banner-classic.png',
    slideImgTablet: 'pages/business/deposits/deposits/banner-classic-tablet.png',
    slideImgMobile:
        'pages/business/deposits/deposits/banner-classic-mobile.webp',
    imageAlt: 'Депозит «Классический»',
    slideTitle: `Депозит «Классический» <br> до ${classic.percent}%`,
    slideValue: [
        {
            value: '',
            name: 'Выплата процентов в конце срока',
        },
    ],
    slideLinks: [
        {
            link: '#deposits-calc',
            title: 'рассчитать',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const businessDepositsSlideUrgent = {
    slideImg: 'pages/business/deposits/deposits/banner-urgent.png',
    slideImgTablet: 'pages/business/deposits/deposits/banner-urgent-tablet.png',
    slideImgMobile:
        'pages/business/deposits/deposits/banner-urgent-mobile.webp',
    imageAlt: 'Депозит «Срочный»',
    slideTitle: `Депозит «Срочный» <br> до ${urgent.percent}%`,
    slideValue: [
        {
            value: '',
            name: 'С возможностью досрочного расторжения',
        },
    ],
    slideLinks: [
        {
            link: '#deposits-calc',
            title: 'рассчитать',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const businessDepositsSlideMinimumBalance = {
    slideImg: 'pages/business/deposits/deposits/banner-minimumBalance.png',
    slideImgTablet: 'pages/business/deposits/deposits/banner-minimumBalance-tablet.png',
    slideImgMobile:
        'pages/business/deposits/deposits/banner-minimumBalance-mobile.webp',
    imageAlt: 'Депозит «С неснижаемым остатком»',
    slideTitle: `Депозит <br> «С неснижаемым остатком» до ${minimumBalance.percent}%`,
    slideValue: [
        {
            value: '',
            name: 'С возможностью досрочного расторжения',
        },
    ],
    slideLinks: [
        {
            link: '#deposits-calc',
            title: 'рассчитать',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideOptions: {
        target: '_self',
        bigContent: true,
    },
};

/**
 * /core/models/pages/business-page/PaymentQRModel.js
 */
export const paymentQR = {
    slideImg: 'pages/business/payment-QR/payment-QR-slide.webp',
    slideImgMobile: 'pages/business/payment-QR/payment-QR-slide-mobile.webp',
    imageAlt: 'Оплата по QR-коду для вашего бизнеса',
    slideTitle: 'Оплата по QR-коду для вашего бизнеса',
    slideValue: [
        {
            value: '',
            name: 'Принимайте оплату смартфоном без карты и NFC',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'подключить СБП',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

/**
 * /core/models/pages/business-page/BusinessModel.js
 * /core/models/pages/business-page/AcquiringModel.js
 */
export const paymentQRBusiness = {
    slideImg: 'pages/business/payment-QR/payment-QR-slide.webp',
    slideImgMobile: 'pages/business/payment-QR/payment-QR-slide-mobile.webp',
    imageAlt: 'Оплата по QR-коду для вашего бизнеса',
    slideTitle: 'Оплата по QR-коду для вашего бизнеса',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: 'Принимайте оплату смартфоном без карты и NFC',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: '/business/payment-qr',
            title: 'Подробнее',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const repaymentCreditsSlide = {
    slideImg: 'pages/for-individuals/repayment-credits/banner.jpg',
    slideImgMobile: 'pages/for-individuals/repayment-credits/time-mobile.png',
    slideImgMobileVertical:
        'pages/for-individuals/repayment-credits/time-mob.jpg',
    imageAlt: 'Кредитные каникулы и реструктуризация кредитов',
    slideTitle: 'Кредитные каникулы и&nbsp;реструктуризация кредитов',
    slideLinks: [
        {
            id: nanoid(),
            link: 'https://www.centrinvest.ru/cabinet/credit-vacation',
            title: 'подать заявку',
        },
    ],
    slideOptions: {
        target: '_self',
        isRelative: true,
    },
};

export const repaymentCreditsSlideBusiness = {
    slideImg: 'pages/for-individuals/repayment-credits/banner.jpg',
    slideImgMobile: 'pages/for-individuals/repayment-credits/time-mobile.png',
    slideImgMobileVertical: 'pages/for-individuals/repayment-credits/time-mob.jpg',
    imageAlt: 'Кредитные каникулы для бизнеса',
    slideTitle: 'Кредитные каникулы для бизнеса',
    slideLinks: [
        {
            id: nanoid(),
            link: '/about/contacts#feedback-form',
            title: 'подать заявку',
        },
    ],
    slideOptions: {
        target: '_self',
        isRelative: true,
    },
};

export const bkiSlide = {
    mainSlide: true,
    slideImg: 'components/business-page/online-credit-bg.png',
    slideImgTablet: 'components/business-page/online-credit-bg1-780.png',
    slideImgMobile: 'components/business-page/online-credit-bg-mobile.webp',
    slideTitle: 'Оформление<br>согласия банку',
    slideOptions: {
        iconValue: true,
        light: false,
    },
    slideLinks: [
        {
            id: nanoid(),
            link: '/business/bank-agreement/form',
            title: 'СОГЛАСИЯ ДЛЯ ФЛ',
            additionalClasses: ['cibButton_main'],
        },
        {
            id: nanoid(),
            link: '/business/bank-agreement/sign-bki-form',
            title: 'СОГЛАСИЯ ДЛЯ ЮЛ',
            additionalClasses: ['cibButton_main'],
        },
    ],
    slideValue: [
        {
            value: '',
            name: 'Без посещения банка',
        },
        {
            value: '',
            name: 'экономия времени',
        },
        {
            value: '',
            name: 'экономия бумаги',
        },
    ],
};

export const zeroRKO = {
    slideImg: 'pages/business/rko/zero-rko.png',
    slideImgMobile: 'pages/business/rko/zero-rko-mobile.webp',
    imageAlt: 'Обнуляем комиссию по РКО для новых клиентов',
    slideTitle: 'Обнуляем комиссию по&nbsp;РКО для новых клиентов',
    slideValue: [
        {
            value: '',
            name: '<span>&bull;</span>&nbsp;&nbsp;до 1,5 млн руб переводы на счета физических лиц без комиссии',
        },
        {
            value: '',
            name: '<span>&bull;</span>&nbsp;&nbsp;до 1 млн руб. внесение наличных в АТМ без комиссии',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'открыть счет',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
        footnote: `
            Для всех новых клиентов, которые откроют р/с в период 05.12.2023 - 29.02.2024 на 6 месяцев,
            далее (с седьмого месяца) — по тарифам банка. Акция распространяется на все тарифы РКО.
        `,
    },
};

export const promotionAcquiring = {
    slideImg: 'promotions/promotion-acquiring.png',
    slideImgMobile: 'promotions/promotion-acquiring-mobile.webp',
    imageAlt: 'Эквайринг – 0,99%',
    slideTitle: 'Эквайринг – 0,99% для начинающего бизнеса',
    slideValue: [
        {
            value: '',
            name: `Ставка&nbsp;0,99% действует первые 6&nbsp;месяцев,
            далее&nbsp;&mdash; по&nbsp;действующим тарифам банка`,
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'оформить',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
        footnote: `Для организаций и&nbsp;индивидуальных предпринимателей, с&nbsp;момента регистрации которых
        прошло менее 3&nbsp;месяцев. Предложения действительно до&nbsp;&laquo;31&raquo; декабря 2024&nbsp;г.`,
    },
};

export const transferB2B = {
    slideImg: 'pages/business/transfer-b2b/transfer-banner.png',
    slideImgMobile: 'pages/business/transfer-b2b/transfer-banner-mobile.png',
    imageAlt: 'Мгновенные переводы B2B',
    slideTitle: 'Мгновенные <br> переводы B2B',
    slideValue: [
        {
            value: '',
            name: 'Зачисление средств на счет получателя <br> происходит в пределах 1 минуты',
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: '/business/transfer-b2b',
            title: 'подробнее',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
        loop: true,
    },
};

export const transferB2BPage = {
    ...transferB2B,
    slideLinks: [],
    containerClasses: ['transfer-b2b-page'],
};

export const webTspBanner = {
    slideImg: 'pages/business/web-tsp/banner.png',
    slideImgMobile: 'pages/business/web-tsp/banner-mobile.webp',
    imageAlt: 'ВебТСП - прием оплат через QR-код для вашего бизнеса',
    slideTitle: 'ВебТСП - прием оплат через QR-код для вашего бизнеса',
    slideLinks: [
        {
            id: nanoid(),
            link: '/business/web-tsp',
            title: 'подробнее',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
        bigContent: true,
    },
};

export const webTspBannerBuisness = {
    slideImg: 'pages/business/web-tsp/banner.png',
    slideImgMobile: 'pages/business/web-tsp/banner-mobile.webp',
    imageAlt: 'ВебТСП - прием оплат через QR-код для вашего бизнеса',
    slideTitle: 'ВебТСП - прием оплат через QR-код для вашего бизнеса',
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'Подключить',
            additionalClasses: ['cibButton_main', 'cibButton_big'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const leadMagnetSlideBusiness = {
    slideImg: 'pages/business/lead-magnet/banner.png',
    slideImgMobile: 'pages/business/lead-magnet/banner-mobile.png',
    imageAlt: 'По каким признакам налоговая решит проверить ваш бизнес',
    slideTitle: 'По каким признакам налоговая решит проверить ваш бизнес',
};

export const newsClientAcquiringBanner = {
    slideImg: 'pages/promo-pages/news-client-acquiring/banner.png',
    slideImgMobile: 'pages/promo-pages/news-client-acquiring/banner-mobile.png',
    imageAlt: 'Ваш бизнес заслуживает выгодных решений',
    slideTitle: 'Ваш бизнес заслуживает выгодных решений',
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'Подать заявку',
            additionalClasses: ['cibButton_main', 'cibButton_large'],
        },
    ],
    slideValue: [
        {
            value: '',
            name: `
                Эквайринг 0,99% на 4 месяца — если ваш путь <br> в бизнесе только начинается
            `,
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const newsClientAcquiringBannerPages = {
    ...newsClientAcquiringBanner,
    slideLinks: [
        {
            id: nanoid(),
            link: '/promotions/new-clients-acquiring',
            title: 'Подробнее',
            additionalClasses: ['cibButton_main', 'cibButton_large'],
        },
    ],
};

export const onlineCashboxFreeBanner = {
    slideImg: 'pages/promo-pages/online-cashbox-free/banner.png',
    slideImgMobile: 'pages/promo-pages/online-cashbox-free/banner-mobile.png',
    imageAlt: 'Онлайн-касса для торговых точек — бесплатно',
    slideTitle: 'Онлайн-касса для торговых точек — бесплатно',
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'Подать заявку',
            additionalClasses: ['cibButton_main', 'cibButton_large'],
        },
    ],
    slideValue: [
        {
            value: '',
            name: `
                При заключении договора эквайринга до 31 июля включительно. Экономия от 50 000₽
            `,
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const onlineCashboxFreeBannerPages = {
    slideImg: 'pages/promo-pages/online-cashbox-free/banner.png',
    slideImgMobile: 'pages/promo-pages/online-cashbox-free/banner-mobile.png',
    imageAlt: 'Решение для соблюдения ФЗ № 54 — под ключ',
    slideTitle: 'Решение для соблюдения ФЗ № 54 — под ключ',
    isMainSlide: false,
    slideLinks: [
        {
            id: nanoid(),
            link: '/promotions/online-cashbox-free',
            titleFn({path}) {
                return ['acquiring', 'opening-and-maintaining-account'].some((p) => path.includes(p))
                    ? 'подать заявку'
                    : 'подробнее';
            },
            additionalClasses: ['cibButton_main', 'cibButton_large'],
        },
    ],
    slideValue: [
        {
            value: '',
            name: `
                Онлайн-касса для торговых точек – бесплатно при
                заключении договора до 31 июля. Экономия от 50 000 ₽
            `,
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const ResortAcquiring = {
    slideImg: 'pages/promo-pages/resort-acquiring/banner.png',
    slideImgMobile: 'pages/promo-pages/resort-acquiring/banner-mobile.png',
    imageAlt: 'Поддержим ваш бизнес на курортах',
    slideTitle: 'Поддержим ваш бизнес <br> на курортах',
    isMainSlide: false,
    slideValue: [
        {
            value: '',
            name: `
                Эквайринг от 0,99%, кредиты до 5 млн ₽<br>Успейте подать заявку до 30 сентября
            `,
        },
    ],
    slideLinks: [
        {
            id: nanoid(),
            link: `#${CREDIT_FORM_ID}`,
            title: 'Оставить заявку',
            additionalClasses: ['cibButton_main', 'cibButton_large'],
        },
    ],
    slideOptions: {
        target: '_self',
    },
};

export const ResortAcquiringPage = {
    ...ResortAcquiring,
    slideOptions: {
        target: '_blank',
        regions: [KK_ID, SK_ID, RA_ID],
    },
    slideLinks: [
        {
            id: nanoid(),
            link: '/promotions/resort-acquiring',
            title: 'Подробнее',
            additionalClasses: ['cibButton_main', 'cibButton_large'],
        },
    ],
};
